'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginButton = undefined;

var _themeProvider = require('@spp/theme-provider');

var _LoginButton = require('./LoginButton');

var _LoginButton2 = _interopRequireDefault(_LoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.LoginButton = _LoginButton2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-login-button')(_LoginButton2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/LoginButton/index.js
 ** module id = 600
 ** module chunks = 1
 **/